import { ISearchListColumn } from 'component/Search/types';
import { TFunction } from 'i18next';
import { hydrateStandardIColumn } from './hydrateStandardIColumn';

/** Takes an array of IColumn-like items, and hydrates several standardized parameters for
 * use in an office fabric DetailsList.
 * @see hydrateStandardIColumn (this basically just maps that fn)
 * @param columnArray Array to hydrate into standardized columns
 * @returns List of hydrated columns
 */
export const hydrateStandardIColumnList = (
  columnArray: Partial<ISearchListColumn>[],
  t: TFunction
): ISearchListColumn[] => {
  return columnArray.map(col => hydrateStandardIColumn({ ...col }, t));
};
